import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getVideos,
  createVideo,
  updateVideo,
  deleteVideo,
  getVideoTypes,
  getBreadCrumbInformation,
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import Grid from "../Common/Grid";
import {
  showSuccessToastMessage,
  showErrorToastMessage,
  appendBrightcoveScript,
  emptyCheck,
  isInt,
  getParameterByName,
} from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
// import * as CONSTANT from "../../../../constants";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { getBrightcoveAccountId } from "../../../../localstorage-service";
import RequiredField from "../Common/RequiredField";
import CKEditor from "ckeditor4-react";
import { toolbarConfig } from "../../../../constants";

const streamUrl = "https://web.microsoftstream.com/video/";
class AdminVideos extends Component {
  state = {
    moduleName: "",
    learningCategoryName: "",
    contentCategoryName: "",
    jobrolegroupName: "",
    mastervideos: [],
    videos: [],
    selectedVideo: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: "",
    videotypes: [],
    videotypesact: [],
  };
  componentDidMount() {
    // console.log(this.props);
    this.getVideosFromService();
    this.getBreadCrumbInformationFromService();
    this.getVideoTypesFromService();
  }
  getBreadCrumbInformationFromService() {
    getBreadCrumbInformation(
      this.props.match.params.moduleid,
      this.props.match.params.subcategoryid,
      this.props.match.params.videocategoryid
    ).then((response) => {
      this.setState({
        moduleName: response.data.Module,
        learningCategoryName: response.data.LearningCategory,
        contentCategoryName: response.data.ContentCategory,
      });
    });
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }
  getVideosFromService() {
    // console.log("getVideosFromService");
    // console.log(this.props.match.params);
    this.showSpinner(true);
    if (this.props.learning) {
      getVideos(
        true,
        this.props.match.params.learningid,
        this.props.match.params.subcategoryid,
        this.props.match.params.videocategoryid
      )
        .then((response) => {
          this.showSpinner(false);
          // console.log("appendBrightcoveScript");
          appendBrightcoveScript();
          // console.log(response.data);
          this.setState({ videos: response.data, mastervideos: response.data });
        })
        .catch((error) => {
          this.showSpinner(false);
          // console.log(error);
          this.showErrorMessage(error);
        });
    }

    if (this.props.workflow) {
      getVideos(false, this.props.match.params.workflowid, 0, this.props.match.params.videocategoryid).then(
        (response) => {
          // console.log("appendBrightcoveScript");
          this.showSpinner(false);
          // console.log(response.data);
          this.setState({ videos: response.data, mastervideos: response.data });
          appendBrightcoveScript();
        }
      );
    }
  }
  getVideoTypesFromService() {
    let arrVideoTypes = [];
    getVideoTypes().then((response) => {
      this.setState({
        videotypesact: response.data,
      });
      for (let videotype of response.data) {
        arrVideoTypes.push(
          <option key={videotype.Id} value={videotype.Id}>
            {videotype.Name}
          </option>
        );
      }
      this.setState({ videotypes: arrVideoTypes });
    });
  }

  editVideo = (state) => {
    const newState = {
      ...state,
      BrightcoveVideoId: streamUrl + state.BrightcoveVideoId,
    };
    this.setState({
      action: "edit",
      selectedVideo: newState,
      showModal: true,
      modalTitle: "Edit Content",
      errorMessage: "",
    });
  };

  deleteVideo(state) {
    this.setState({
      action: "delete",
      selectedVideo: state,
      modalDeleteTitle: "Delete Content",
      showDeleteModal: true,
    });
  }
  addVideo() {
    const maxOrder = this.state.videos.length > 0 ? Math.max(...this.state.videos.map((o) => o.Order)) : 0;
    let nextOrder = maxOrder + 1;
    this.setState({
      action: "add",
      selectedVideo: { Order: nextOrder, VideoTypeId: -1 },
      showModal: true,
      modalTitle: "Add Content",
      errorMessage: "",
    });
  }
  onHideModal() {
    this.setState({
      showModal: false,
    });
  }

  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Content");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false,
    });
  }
  createVideoService(data) {
    createVideo(data)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideModal();
        this.showSuccessMessage(data.Name);
        this.getVideosFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
        this.onHideModal();
      });
  }
  validate(data) {
    // console.log(data);
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }

    if (data.VideoTypeId === -1) {
      this.setState({ errorMessage: "Content type cannot be blank" });
      return false;
    }

    if (emptyCheck(data.Order)) {
      this.setState({ errorMessage: "Order cannot be blank" });
      return false;
    }
    if (!isInt(data.Order)) {
      this.setState({ errorMessage: "Order only accepts numerical values" });
      return false;
    }
    if (data.VideoTypeId === 1 && emptyCheck(data.BrightcoveVideoId)) {
      this.setState({ errorMessage: "MS Stream Url cannot be blank" });
      return false;
    }
    if (data.VideoTypeId === 1) {
      if (
        data.BrightcoveVideoId.indexOf(streamUrl) === -1 ||
        data.BrightcoveVideoId.toLowerCase() === streamUrl.toLowerCase()
      ) {
        this.setState({
          errorMessage: "Invalid MS Stream Url. Must be of format: https://web.microsoftstream.com/video/xxxx",
        });
        return false;
      }
    }
    // if (!isInt(data.BrightcoveVideoId)) {
    //   this.setState({ errorMessage: "BrightcoveVideoId only accepts numerical values" });
    //   return false;
    // }
    if (data.VideoTypeId === 1 && emptyCheck(data.Time)) {
      this.setState({ errorMessage: "Time cannot be blank" });
      return false;
    }
    if (data.VideoTypeId === 1) {
      if (data.Time.indexOf(":") === -1) {
        this.setState({ errorMessage: "Time must be in format hh:mm:ss" });
        return false;
      }
      const timeSplitted = data.Time.split(":");
      if (timeSplitted.length !== 3) {
        this.setState({ errorMessage: "Time must be in format hh:mm:ss" });
        return false;
      }

      if (timeSplitted[0].length !== 2 || timeSplitted[1].length !== 2 || timeSplitted[0].length !== 2) {
        this.setState({
          errorMessage: "Time must be in format hh:mm:ss and hh,mm,ss should be two digits",
        });
        return false;
      }

      const hours = parseInt(timeSplitted[0], 10);
      const mins = parseInt(timeSplitted[1], 10);
      const secs = parseInt(timeSplitted[2], 10);

      if (isNaN(hours) || isNaN(mins) || isNaN(secs)) {
        this.setState({
          errorMessage: "Time must be in format hh:mm:ss and allows only integer",
        });
        return false;
      }

      if (mins > 60) {
        this.setState({
          errorMessage: "Time - minutes cannot be greater than 60",
        });
        return false;
      }

      if (secs > 60) {
        this.setState({
          errorMessage: "Time - seconds cannot be greater than 60",
        });
        return false;
      }
    }

    // const uploadedDocument = document.getElementById("document");
    // if (!data.FilePath) {
    //   if (
    //     (data.VideoTypeId === 2 || data.VideoTypeId === 3 || data.VideoTypeId === 4) &&
    //     (uploadedDocument === undefined || uploadedDocument.files.length === 0)
    //   ) {
    //     this.setState({ errorMessage: "Please upload a document" });
    //     return false;
    //   }
    // }
    // if (uploadedDocument && uploadedDocument.files[0] && uploadedDocument.files[0].size > 26214400) {
    //   this.setState({ errorMessage: "Please upload a file less than 25 MB" });
    //   return false;
    // }
    if (data.VideoTypeId === 2 && data.FilePath.indexOf(".pdf") === -1) {
      this.setState({ errorMessage: "Please upload a pdf ending with .pdf extension" });
      return false;
    }

    if (data.VideoTypeId === 2 && data.FilePath.indexOf("https") === -1) {
      this.setState({ errorMessage: "Please upload a pdf on secure server with https" });
      return false;
    }

    return true;
  }

  saveVideo() {
    let data = {
      Id: this.state.action === "edit" ? this.state.selectedVideo.Id : 0,
      VideoCategoryId: this.props.match.params.videocategoryid,
      IsTheory: false, //this.refs["chkTheory"].checked,
      // IntroImagePath:  this.props.workflow
      //   ? null
      //   : this.state.action === "edit"
      //     ? this.state.selectedVideo.IntroImagePath
      //     : "",
      // ImageHeader: this.props.workflow ? null : this.refs["txtImageHeader"].value,
      Name: this.refs["txtVideo"].value,
      Order: this.refs["txtOrder"].value,
      BrightcoveVideoId: this.refs["txtBrightcoveVideoId"] ? this.refs["txtBrightcoveVideoId"].value : null,
      BrightcoveAccountId: getBrightcoveAccountId(),
      Tid: this.state.action === "edit" ? this.state.selectedVideo.Tid : 0,
      IsRemoveIntroImage: false, // this.state.selectedVideo.IsRemoveIntroImage,
      Time: this.refs["txtTime"] ? this.refs["txtTime"].value : null,
      VideoTypeId: this.state.selectedVideo.VideoTypeId,
      HTML: this.state.selectedVideo.HTML,
      FilePath: this.refs["txtFilePath"] && this.refs["txtFilePath"].value, //this.state.selectedVideo.FilePath,
    };
    if (this.validate(data)) {
      if (data.VideoTypeId === 1) {
        let bcVIdParsedt1 = data.BrightcoveVideoId.replace(streamUrl, "");
        if (bcVIdParsedt1.indexOf("?") !== -1) {
          const qCharAt = bcVIdParsedt1.indexOf("?");
          bcVIdParsedt1 = bcVIdParsedt1.substring(0, qCharAt);

          //Case where url contains start time
          if (data.BrightcoveVideoId.toLowerCase().indexOf("st=") !== -1) {
            const st = getParameterByName("st", data.BrightcoveVideoId);
            bcVIdParsedt1 = `${bcVIdParsedt1}?st=${st}`;
          }
        }
        data.BrightcoveVideoId = bcVIdParsedt1;
      }

      // const uploadedDocument = document.getElementById("document");

      const that = this;
      // let promiseUploadDocument = null;

      // if (uploadedDocument === undefined || uploadedDocument === null || uploadedDocument.files.length === 0) {
      //   promiseUploadDocument = Promise.resolve();
      // } else {
      //   promiseUploadDocument = new Promise(function (resolve, reject) {
      //     let formdata = new FormData();
      //     formdata.append("file", uploadedDocument.files[0]);
      //     const videotypes = [...that.state.videotypesact];
      //     const videoTypeName = videotypes.filter((d) => d.Id === data.VideoTypeId)[0].Name;
      //     uploadVideoDocument(formdata, videoTypeName)
      //       .then((resfilePath) => {
      //         data.OldFilePath = data.FilePath;
      //         data.FilePath = resfilePath.data;
      //         console.log(resfilePath);
      //         resolve();
      //       })
      //       .catch((error) => {
      //         reject(error);
      //       });
      //   });
      // }
      this.showSpinner(true);
      // Promise.all([promiseUploadDocument])
      //   .then(function () {
      if (that.state.action === "add") {
        that.createVideoService(data);
      } else {
        that.updateVideoService(data);
      }
      // })
      // .catch((error) => {
      //   that.showSpinner(false);
      //   that.showErrorMessage(error);
      //   console.log(error);
      // });
    }
  }

  updateVideoService(data) {
    updateVideo(data)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideModal();
        this.showSuccessMessage(data.Name);
        this.getVideosFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
        this.onHideModal();
      });
  }
  confirmDeleteVideo() {
    this.showSpinner(true);
    deleteVideo(this.state.selectedVideo.Id)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedVideo.Name);
        this.getVideosFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleVideoChange = (event) => {
    let selectedVideo = this.state.selectedVideo;
    selectedVideo.Name = event.target.value;
    this.setState({ selectedVideo: selectedVideo });
  };

  handleSearchTermChange = (event) => {
    let filteredVideos = this.state.mastervideos.filter((d) => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        videos: filteredVideos,
        searchTerm: event.target.value,
      });
    else
      this.setState({
        videos: this.state.mastervideos,
        searchTerm: event.target.value,
      });
  };
  removeIntroImageClicked(e) {
    // console.log(e.target.checked);
    let selectedVideo = this.state.selectedVideo;
    selectedVideo.IsRemoveIntroImage = e.target.checked;
    this.setState({ selectedVideo: selectedVideo });
    // console.log(this.state.selectedVideo);
  }
  videoTypeChanged = (e) => {
    const selectedVideo = { ...this.state.selectedVideo };
    selectedVideo.VideoTypeId = parseInt(e.target.value, 10);
    selectedVideo.OldFilePath = selectedVideo.FilePath;
    selectedVideo.FilePath = null;
    this.setState(
      {
        selectedVideo,
      },
      () => {
        console.log("selectedVideo", selectedVideo);
      }
    );
  };
  onEditorChange = (evt) => {
    const selectedVideo = { ...this.state.selectedVideo };
    selectedVideo.HTML = evt.editor.getData();
    this.setState({
      selectedVideo,
    });
  };
  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">
          Content
          {this.state.videos.length > 0 ? ` - ${this.state.videos[0].VideoCategoryName}` : ""}
        </h1>
        {this.props.workflow && (
          <AdminBreadcrumb
            data={[
              { name: "Home", link: "/admin/modules/" },
              { name: "Modules", link: "/admin/modules/" },
              {
                name: "Categories",
                link: `/admin/${this.props.match.params.moduleid}/categories/`,
              },
              {
                name: "Video Categories",
                link: `/admin/${this.props.match.params.moduleid}/${this.props.match.params.workflowid}/workflowcategories/`,
              },
              { name: "Videos" },
            ]}
          />
        )}
        {this.props.learning && (
          <AdminBreadcrumb
            data={[
              { name: "Home", link: "/admin/modules/" },
              { name: this.state.moduleName, link: "/admin/modules/" },
              // { name: "Categories", link: `/admin/${this.props.match.params.moduleid}/categories/` },
              {
                name: this.state.learningCategoryName,
                link: `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningcategories/`,
              },
              {
                name: this.state.contentCategoryName,
                link: `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningvideocategories/${this.props.match.params.subcategoryid}`,
              },
              { name: "Content" },
            ]}
          />
        )}
        <button className="btn btn-default add-btn" onClick={() => this.addVideo()}>
          Add Content
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Type", "Name", "Time", "Order"]}
          values={this.state.videos}
          linkProperty="Name"
          indexName="Id"
          properties={["Id", "VideoType", "Name", "Time", "Order", "Action"]}
          edit={(value) => this.editVideo(value)}
          delete={(value) => this.deleteVideo(value)}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveVideo()}
          form={this.addeditform}
          type="Content"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              maxLength="100"
              type="text"
              className="form-control"
              ref="txtVideo"
              defaultValue={this.state.selectedVideo.Name}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Content Type:
            </label>
            <select
              ref="selVideoType"
              onChange={(e) => this.videoTypeChanged(e)}
              className="form-control"
              defaultValue={this.state.selectedVideo.VideoTypeId}
              disabled={this.state.action === "edit" ? "disabled" : false}
            >
              <option value={-1}>Select Content Type</option>
              {this.state.videotypes}
            </select>
          </div>
          {/* <div className="form-group">
            <label>Is Theory?:</label>
            <input
              maxLength="50"
              type="checkbox"
              className="chkBoxCustom"
              ref="chkTheory"
              defaultChecked={this.state.selectedVideo.IsTheory}
            />
          </div> */}
          {/* {this.props.learning && (
            <Aux>
              <div className="form-group">
                <label>Intro Image Heading:</label>
                <input
                  maxLength="50"
                  type="text"
                  className="form-control"
                  ref="txtImageHeader"
                  defaultValue={this.state.selectedVideo.ImageHeader}
                />
              </div>
              <div className="form-group">
                <label>Intro Image (Recommended size 175x790px):</label>
                <input id="file" type="file" className="form-control" ref="fileIntroImage" />
              </div>

              {this.state.selectedVideo.IntroImagePath && (
                <div>
                  <div className="form-group">
                    <label>Remove Intro Image:</label>
                    <input
                      type="checkbox"
                      className="chkBoxCustom"
                      ref="chkRemoveIntroImage"
                      onChange={e => this.removeIntroImageClicked(e)}
                      defaultChecked={this.state.selectedVideo.IsRemoveIntroImage}
                    />
                  </div>
                  {!this.state.selectedVideo.IsRemoveIntroImage && (
                    <img src={CONSTANT.API_BASE_URL + this.state.selectedVideo.IntroImagePath} alt="introimage" />
                  )}
                </div>
              )}
            </Aux>
          )} */}
          {this.state.selectedVideo.VideoTypeId === 1 && (
            <Aux>
              <div className="form-group">
                <label>
                  <RequiredField />
                  MS Stream Video Url:
                </label>
                <input
                  maxLength="300"
                  type="text"
                  className="form-control"
                  ref="txtBrightcoveVideoId"
                  defaultValue={this.state.selectedVideo.BrightcoveVideoId}
                />
              </div>
              <div className="form-group">
                <label>
                  <RequiredField />
                  Video Total Time (must be of format hh:mm:ss):
                </label>
                <input
                  maxLength="20"
                  type="text"
                  className="form-control"
                  ref="txtTime"
                  placeholder="00:01:20"
                  defaultValue={this.state.selectedVideo.Time}
                />
              </div>
            </Aux>
          )}
          {(this.state.selectedVideo.VideoTypeId === 2 ||
            this.state.selectedVideo.VideoTypeId === 3 ||
            this.state.selectedVideo.VideoTypeId === 4) && (
            <Aux>
              <div className="form-group">
                {/* <label>
                  <RequiredField />
                  Upload File:
                </label>
                <input id="document" type="file" className="form-control" ref="videoDocument" /> */}
                <label>
                  <RequiredField />
                  Link(Url of pdf file):
                </label>
                <input
                  type="text"
                  className="form-control"
                  ref="txtFilePath"
                  defaultValue={this.state.selectedVideo.FilePath}
                />
              </div>
            </Aux>
          )}
          {this.state.selectedVideo.VideoTypeId === 5 && (
            <CKEditor
              config={{
                height: "400",
                allowedContent: true,
                extraAllowedContent: "*(*)",
                toolbar: toolbarConfig,
              }}
              onChange={(e) => this.onEditorChange(e)}
              data={this.state.selectedVideo.HTML}
              onBeforeLoad={(CKEDITOR) => (CKEDITOR.disableAutoInline = true)}
            />
          )}

          {/* {this.state.selectedVideo.FilePath && (
            <div>
              <a href={CONSTANT.API_BASE_URL + this.state.selectedVideo.FilePath} target="_blank">
                {this.state.selectedVideo.FilePath}
              </a>
            </div>
          )} */}
          <div className="form-group">
            <label>
              <RequiredField />
              Order:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtOrder"
              defaultValue={this.state.selectedVideo.Order}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedVideo.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          modalTitle={this.state.modalDeleteTitle}
          confirm={() => this.confirmDeleteVideo()}
          name={this.state.selectedVideo.Name}
          type="Content"
        />
      </Aux>
    );
  }
}

export default AdminVideos;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Videos/Videos.js